import { LearningObjectTypes } from '@hendrx/lms/constants';

import { WidgetType } from '../utils/widgetsUtils';

export const LearningObjectPages: Record<LearningObjectTypes, WidgetType.Page | WidgetType.Slide | null> = {
  [LearningObjectTypes.Course]: null,
  [LearningObjectTypes.LearningActivity]: WidgetType.Page,
  [LearningObjectTypes.PlenaryLesson]: WidgetType.Slide,
  [LearningObjectTypes.PBL]: WidgetType.Page
};
